export function isLeapYear(year: number): boolean {
	const d = new Date(year, 1, 28);
	d.setDate(d.getDate() + 1);
	return d.getMonth() === 1;
}

export function getAgeInYears(cprString: string): number {
	const cpr = Number(cprString);
	const century = Math.floor((cpr / 1000) % 10);
	const shortBirthYear = Math.floor(((cpr / 10000) % 100));
	let birthYear = 1900 + shortBirthYear;

	if ((century === 4 || century === 9) && shortBirthYear <= 36) birthYear += 100;
	else if (5 <= century && century <= 8 && shortBirthYear <= 57) birthYear += 100;

	const birthMonth = Math.floor((cpr / 1000000) % 100) - 1;
	const birthDayOfMonth = Math.floor((cpr / 100000000) % 100);

	const birthDate = new Date(birthYear, birthMonth, birthDayOfMonth);
	const today = new Date();

	const birthDay =
		birthMonth === 2 && birthDayOfMonth === 29 && !isLeapYear(today.getFullYear())
			? new Date(today.getFullYear(), birthMonth, birthDayOfMonth - 1)
			: new Date(today.getFullYear(), birthMonth, birthDayOfMonth);

	const birthdayAdjustment = today.getTime() < birthDay.getTime() ? -1 : 0;
	const age = today.getFullYear() - birthDate.getFullYear() + birthdayAdjustment;

	return age;
}
